import LayoutContainer from '../../../layout/layout-container/index';
import DetailField from '../user/detail-field';
import PpcLoadDetailsSelect from './ppc-load-details-select';

const PpcLoadDetails = ({ load }) => (
  <LayoutContainer>
    <div className="mg-bottom-10">
      <DetailField label="User name">
        {load.attributes['first-name']}
        {' '}
        {load.attributes['last-name']}
      </DetailField>
      <DetailField label="PPC account number">
        {load.attributes['account-number']}
      </DetailField>
    </div>
    <PpcLoadDetailsSelect load={load} />
  </LayoutContainer>
);

export default PpcLoadDetails;
